import PageContainer from "../../../components/page-container";

/**
 * Shown when a sub-agent route points at an id that no longer exists —
 * typically after the sub-agent was deleted in another tab.
 */
export default function SubAgentMissing({ navigation }) {
  return (
    <PageContainer title="Sub-Agent" navigationPosition="below-header" navigation={navigation}>
      <div className="flex flex-col items-center justify-center py-20 text-center">
        <p className="text-sm font-medium text-gray-600">
          This sub-agent no longer exists
        </p>
        <p className="text-xs text-gray-400 mt-1">
          It may have been deleted. Pick another one from the sidebar.
        </p>
      </div>
    </PageContainer>
  );
}
